module.exports = __webpack_public_path__ + "img/main.4f5c3734.jpg";